export const FACTURATION_REDUCER_NAME = 'facturation';
